import { useEffect, useState, useRef } from 'react';
import { clarity } from 'react-microsoft-clarity';
import { useLogos } from '../../Hooks/useLogos';
import { useToken } from '../../contexts/TokenContext';
import { CONFIG_STORAGE_KEY, migrateToSessionStorage } from '@/services/tenant/tenantService.js';
import { jwtDecode } from 'jwt-decode';
import { flushNetworkTelemetry } from '@/observability/networkTelemetry';

export const ClarityInit = () => {
  const { clientId } = useLogos();
  const { idToken, tokenVersion } = useToken();
  const [config, setConfig] = useState(null);
  const clarityInitialized = useRef(false);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        migrateToSessionStorage();
        const configStorage = sessionStorage?.getItem(CONFIG_STORAGE_KEY) || "{}";
        const configData = JSON.parse(configStorage); 
        setConfig(configData);
      } catch (error) {
        console.error('Error loading config:', error);
      }
    };

    loadConfig();
  }, [clientId]);

  useEffect(() => {
    if (!config?.FEATURE_FLAGS?.CLARITY_ID) return;

    if (!clarityInitialized.current) {
      clarity.init(config.FEATURE_FLAGS.CLARITY_ID);
      clarityInitialized.current = true;
      flushNetworkTelemetry();
    }
    if (idToken) {
      try {
        const decodedToken = jwtDecode(idToken);
        const participantId = decodedToken['custom:participantId'];
        if (participantId) {
          clarity.identify(participantId, {
            participantId: participantId
          });
        }
      } catch (error) {
        console.error('Erro ao decodificar token para Clarity:', error);
      }
    }
  }, [config, idToken, tokenVersion]);

  return null;
}; 
